import { UserInfo, UserModelSpeedAuthAndType } from 'redux/common/type';
import { checkTime } from '../../utils';

export interface MenuConfig {
    path: string;
    filterFunc?: (adUser: UserInfo & UserModelSpeedAuthAndType) => string;
    title: string;
    icon: string;
    pageTitle: string;
    children?: MenuConfig[];
    includes?: string[];
    filter?: (u: UserInfo & UserModelSpeedAuthAndType) => boolean;
    showNewIcon?: (releaseDate: Parameters<typeof checkTime>[0]) => ReturnType<typeof checkTime>;
    releaseDate?: number;
}

const config: MenuConfig[] = [
    {
        path: '/recommend',
        title: '首页',
        icon: '',
        pageTitle: '首页 - 快手DMP',
    },
    {
        path: '/market/my_population',
        title: '人群集市',
        icon: '',
        pageTitle: '人群集市 - 快手DMP',
        includes: [
            '/market/industry_population',
            '/market/common_population',
            '/market/special',
            '/market/holiday',
            '/market/feature',
            '/market/my_population',
            '/market/props_data',
            '/market/props_data_operation',
            '/logic-diagram',
        ],
    },
    {
        path: '/population/tags-area',
        title: '标签专区',
        icon: 'theme',
        pageTitle: '标签专区 - 快手DMP',
    },
    {
        path: '/portrait',
        title: '人群洞察',
        icon: 'chart',
        pageTitle: '人群洞察 - 快手DMP',
        // 放开人群洞察权限至品牌dmp
        // filter: (userInfo) => !userInfo.isKa,
    },
    {
        path: '/policys/population_price',
        title: '策略中心',
        icon: '',
        pageTitle: '策略中心 - 快手DMP',
        includes: [
            '/policys/population_price',
            '/policys/population-optimize/intelligence-selection',
            '/policys/lead_library',
            '/policys/population_price_create',
        ],
        releaseDate: 1701705600000,
        showNewIcon(releaseDate) {
            return checkTime(releaseDate, 30);
        },
        filterFunc: (adUser) =>
            adUser.dmpStrategyModuleEnable
                ? '/policys/population_price'
                : adUser.dmpPopulationAnalysisWhiteList
                ? '/policys/lead_library'
                : '/policys/population-optimize/intelligence-selection',
        filter: (userInfo) =>
            userInfo?.dmpStrategyModuleEnable ||
            userInfo?.dmpPopulationAnalysisWhiteList ||
            !(userInfo?.authorize === false), // 如果有人群出价策略权限或者有人群优选权限，则展示策略中心
    },
    {
        path: '/analysis-center',
        icon: '',
        title: '分析中心',
        pageTitle: '分析中心 - 快手DMP',
        includes: [
            '/analysis-center/advertise-analysis/list',
            '/analysis-center/advertise-analysis/report',
            '/analysis-center/industry-list',
        ],
        filterFunc: (adUser) =>
            adUser.dmpAdGuideReportAllowList
                ? '/analysis-center/advertise-analysis/list'
                : '/analysis-center/industry-list',
        filter: (userInfo) => userInfo?.dmpAdGuideReportAllowList, // 如果有权限，则展示分析中心
        releaseDate: 1710318057047,
        showNewIcon(releaseDate) {
            return checkTime(releaseDate, 30);
        },
    },
    // {
    //     path: '/population-optimize/intelligence-selection',
    //     title: '人群优化',
    //     icon: 'theme',
    //     pageTitle: '人群优化 - 快手DMP',
    //     includes: ['/population-optimize/intelligence-selection'],
    // },
    // {
    //     path: '/report/insights-taglist',
    //     filterFunc: (adUser) =>
    //         adUser.dmpDataInsightWhiteList
    //             ? '/report/insights-taglist'
    //             : '/report/industry-taglist',
    //     title: '数据洞察',
    //     icon: 'report',
    //     pageTitle: '数据洞察 - 快手DMP',
    //     releaseDate: 1626912000000,
    //     showNewIcon(releaseDate) {
    //         return checkTime(releaseDate, 30);
    //     },
    //     includes: [
    //         '/report/insights-analysis',
    //         '/report/insights-taglist',
    //         '/report/industry-taglist',
    //     ],
    // },
    {
        path: '/crowd-chart',
        title: '报表',
        icon: 'report',
        pageTitle: '投放报表 - 快手DMP',
        filter: (userInfo) => !userInfo.isKa,
    },
    {
        path: '/tools/word-pack',
        title: '工具',
        icon: 'theme',
        pageTitle: '工具箱 - 快手DMP',
        includes: ['/tools/word-pack', '/tools/store-pack', '/tools/word-pack-manage'],
    },
];

export const getPageTitleByPath = (path, configs) => {
    let configArr = [];
    configs.forEach((config) => {
        if (config.children && config.children.length) {
            configArr = configArr.concat(config.children);
        } else {
            configArr.push(config);
        }
    });
    const currentPage = configArr.filter((item) => item.path === path)[0];
    return (currentPage && currentPage.pageTitle) || '';
};

export default config;
